<template>
  <CCol sm="12" class="mt-5 mb-5">
    <h2 class="askTitle">{{ $t('managePlan.questions.title') }}</h2>
    <div class="askSubTitle mt-3 mb-4">{{ $t('managePlan.questions.subtitle') }}</div>
    <CRow class="justify-content-center">
      <CCol sm="10">
        <CCard class="mb-3 mt-3 p-3" v-for="ac in FAQData" :key="ac.id">
          <CButton block class="text-left shadow-none card-header" @click="setAccordion(ac.id)">
            <h5 style="color: #343a40" class="m-0">{{ ac.title }}</h5>
            <CIcon v-if="accordion != ac.id || accordion === false" class="plusIcon mr-2" name="plus" :height="15" viewBox="0 0 32 32" />
            <CIcon v-if="accordion == ac.id" class="plusIcon mr-2" name="minus" :height="15" viewBox="0 0 32 32" />
          </CButton>
          <CCollapse :show="accordion === ac.id">
            <CCardBody>
              <div v-html="ac.text"></div>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
export default {
  name: 'AskedQuestions',
  data() {
    return {
      collapse: false,
      cardCollapse: true,
      innerCollapse: false,
      accordion: '000',
    }
  },
  components: {},
  computed: {
    FAQData() {
      const FAQData = []

      const questions = this.$t('faq.askedQuestions.questions')
      const responses = this.$t('faq.askedQuestions.responses')

      for (const key in questions) {
        if (questions.hasOwnProperty(key) && responses.hasOwnProperty(key)) {
          if (key == '001') continue // TODO: Método alternativo devido quebra do plano trial em live REMOVER

          FAQData.push({
            id: key,
            title: questions[key],
            text: responses[key],
          })
        }
      }

      return FAQData
    },
  },
  methods: {
    setAccordion(id) {
      this.accordion = this.accordion === id ? false : id
    },
  },
}
</script>

<style lang="scss">
.askTitle {
  text-align: center;
}

.askSubTitle {
  text-align: center;
  color: #868e96;
  font-size: 18px;
}

.plusIcon {
  position: absolute;
  right: 25px;
  top: 40%;
}
</style>
